import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f80ecde&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1f80ecde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80ecde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f80ecde')) {
      api.createRecord('1f80ecde', component.options)
    } else {
      api.reload('1f80ecde', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f80ecde&scoped=true&", function () {
      api.rerender('1f80ecde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/contractAfterInfo/index.vue"
export default component.exports